import { render, staticRenderFns } from "./HeaderContainer.vue?vue&type=template&id=0ec800c1&"
import script from "./HeaderContainer.vue?vue&type=script&lang=js&"
export * from "./HeaderContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HepLogo: require('/vercel/path0/components/general/HepLogo.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default})
